import { render } from "./PetNameSelector.vue?vue&type=template&id=639d416d&scoped=true"
import script from "./PetNameSelector.vue?vue&type=script&lang=js"
export * from "./PetNameSelector.vue?vue&type=script&lang=js"

import "./PetNameSelector.vue?vue&type=style&index=0&id=639d416d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639d416d"]])

export default __exports__